module.exports = __webpack_public_path__ + "img/activity2.cac7dfb9.png";